import React, { FunctionComponent, MouseEvent } from 'react'

import { useHistory } from '../../../../../Router'

import { IProps } from './IProps'
import { LogoImg } from './style'

/**
 * OB-499 / OB-494: Render the link as a plain <a> with an onClick that calls
 * history.push, instead of react-router-dom <Link>. <Link>'s click handler
 * routes through both react-router and (transitively, on react-native-web)
 * the synthetic touch system, which on some Android OEM browsers (OPPO/
 * ColorOS) resolves the click against the wrong element after layout
 * changes — producing the OB-494 phantom navigation. A native <a onClick>
 * uses only the browser's own hit-testing.
 */
export const ConditionalLink: FunctionComponent<IProps> = ({
  to,
  condition,
  logo,
}) => {
  const history = useHistory()

  if (!condition) {
    return <LogoImg resizeMode="contain" source={{ uri: `${logo}` }} />
  }

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Allow the user to open in a new tab via modifier keys / middle click.
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    history.push(to)
  }

  return (
    <a href={to} onClick={handleClick} style={{ textDecoration: 'none' }}>
      <LogoImg resizeMode="contain" source={{ uri: `${logo}` }} />
    </a>
  )
}
